import * as React from 'react';
import { Container, Row, Col, Button, Breadcrumb, Card, ListGroup, Accordion } from 'react-bootstrap';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import autobind from 'autobind-decorator';

import '../Assets/concept_student.sass';
import ListAltIcon from '@material-ui/icons/ListAlt';
import DescriptionIcon from '@material-ui/icons/Description';
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo';
import VideoTOC from 'Screens/Video/Student/Components/VideoTOC';
import Video from 'Screens/Video/Student/Components/Video';
import 'Screens/Video/Student/Assets/videoStud.sass';


export interface IConceptProps {
    forum: any;
    data: any;
}

export interface IConceptState {
    currentItem: any;
    startTime: number;
}

class Concept extends React.Component<IConceptProps & RouteComponentProps, IConceptState> {
    constructor(props: IConceptProps & RouteComponentProps) {
        super(props);

        this.state = {
            currentItem: null,
            startTime: 0
        }
    }

    @autobind
    public handleNav(flag) {
        const { id, group_playlist } = this.props.data;
        const index = group_playlist.findIndex(e => e.id === id);
        const prev = group_playlist[index - 1].id;
        const next = group_playlist[index + 1].id;

        if (flag) {
            this.props.history.push(`/frontend/concept/${next}`)
        }
        else {
            this.props.history.push(`/frontend/concept/${prev}`)
        }
    }

    @autobind
    public setCurrentItem(index) {
        this.setState({
            currentItem: this.props.data.playlist[index]
        })
    }

    @autobind
    public handleTimeUpdate(index) {
        if (this.state.currentItem.type === 'video') {
            this.setState({
                startTime: this.state.currentItem.content.markers[index]['time']
            })
        }
    }

    public render() {
        return (

            <Container>
                <Row>
                    <Col md-span={12}>
                        <h3 className="course-title">
                            <Link to={`/courseware/course/${this.props.data.course} /`}>
                                {this.props.data.course_title}
                            </Link>
                        </h3>
                    </Col>
                </Row>

                <Row>
                    <Col md-span={12}>
                        <Breadcrumb>
                            <Breadcrumb.Item href="#">Home</Breadcrumb.Item>
                            <Breadcrumb.Item href="https://getbootstrap.com/docs/4.0/components/breadcrumb/">
                                Library
                            </Breadcrumb.Item>
                            <Breadcrumb.Item active>Data</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>

                <Row>
                    <Col md-span={12}>
                        <h4 className='concept-header'>{this.props.data.title}</h4>
                        <p className='concept-header'>{this.props.data.description}</p>
                    </Col>
                </Row>

                <Row className="concept-nav-buttons">
                    <Button className="navBtn" variant='light' onClick={() => { this.handleNav(false) }}>
                        <span>
                            <NavigateBeforeIcon fontSize="small" />
                                Previous
                            </span>
                    </Button>
                    <Button className="navBtn" variant='light' onClick={() => { this.handleNav(true) }}>
                        <span>
                            Next
                            <NavigateNextIcon fontSize="small" />
                        </span>
                    </Button>
                </Row>
                <br />
                <Row>
                    <Col md={{span:4}}>
                        <Card >
                            <Card.Header> Modules </Card.Header>
                            <ListGroup variant="flush">
                                {
                                    this.props.data.playlist.map((mod, i) => {
                                        const type = mod.type;
                                        const { id, title, markers } = mod.content;

                                        if (type === 'video') {
                                            return (
                                                <Accordion key={id} defaultActiveKey="0">
                                                    <Card>
                                                        <Accordion.Toggle as={ListGroup.Item} action onClick={() => { this.setCurrentItem(i) }} eventKey="0">
                                                            <span>
                                                                <OndemandVideoIcon />
                                                                {title}
                                                            </span>
                                                        </Accordion.Toggle>

                                                        <Accordion.Collapse eventKey="0">
                                                            <Card.Body>
                                                                <div>Table of Content</div>
                                                                <VideoTOC markers={markers} clickCallback={this.handleTimeUpdate} />
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                </Accordion>
                                            )

                                        }
                                        else if (type === 'quiz') {
                                            return (
                                                <ListGroup.Item key={id} action onClick={() => this.setCurrentItem(i)}>
                                                    <span>
                                                        <DescriptionIcon />
                                                        {title}
                                                    </span>
                                                </ListGroup.Item>
                                            )
                                        }
                                        else {
                                            return (
                                                <ListGroup.Item key={id} action onClick={() => this.setCurrentItem(i)}>
                                                    <span>
                                                        <ListAltIcon />
                                                        {title}
                                                    </span>
                                                </ListGroup.Item>
                                            )
                                        }
                                    })
                                }
                            </ListGroup>
                        </Card>
                    </Col>
                    <Col>
                        {
                            !this.state.currentItem ?
                                <div>
                                    Select a Module
                                </div>
                                :
                                this.state.currentItem.type === 'video' ?
                                    <div className="video-panel">
                                        <Row>
                                            <Col className="video-panel-heading" md-span={12}>
                                                <h4>{this.state.currentItem.content.title}</h4>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md-span={12}>
                                                <Video videoFile={this.state.currentItem.content.video_file}
                                                    videoStartTime={this.state.startTime}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                    :
                                    this.state.currentItem.type === 'document' ?
                                        <a href={this.state.currentItem.content.document_file} target="_blank">View</a>
                                        :
                                        <div>Quiz</div>
                        }
                    </Col>
                </Row>

            </Container>

        );
    }
}

export default withRouter(Concept);